import dayjs from 'dayjs'

export const customerAllocationFilter = {
  searchOption: {
    customerNumber: false,
    customerName: false,
    address: false,
    installerName: false,
  },
  searchData: '',
  assignStatus: 'all',
  customerStatus: 'all',
}

export const customerInfoFilter = (pageState: any) => {
  return {
    searchOption: {
      customerNumber: false,
      customerName: false,
      address: false,
      managerName: false,
      memo: false,
      serialNumber: false,
      installerName: false,
    },
    searchData: '',
    deviceStatus: pageState?.deviceStatus === undefined ? 'all' : pageState?.deviceStatus,
    efosStatus: pageState?.efosStatus === undefined ? 'all' : pageState?.efosStatus,
    freezeWarningType:
      pageState?.freezeWarningType === undefined ? 'all' : pageState?.freezeWarningType,
    recognizedType: pageState?.recognizedType === undefined ? 'all' : pageState?.recognizedType,
    deviceType: pageState?.deviceType === undefined ? 'all' : pageState?.deviceType,
    batteryStatus: pageState?.batteryStatus === undefined ? 'all' : pageState?.batteryStatus,
    signalStrength: 'all', // 전파세기
    temperature: 'all', //온도
    customerStatus: 'all', //as
    isRevised: 'all', //보정
    processStatus: '',
    rowPerPage: 30,
    page: 1,
  }
}

export const customerInfoExtendFilter = (pageState: any) => {
  return {
    searchOption: {
      customerNumber: false,
      customerName: false,
      address: false,
      managerName: false,
      memo: false,
      serialNumber: false,
      installerName: false,
    },
    searchData: '',
    deviceStatus: pageState?.deviceStatus === undefined ? 'all' : pageState?.deviceStatus, // 단말기 통신 상태
    efosStatus: pageState?.efosStatus === undefined ? 'all' : pageState?.efosStatus, //계량기 통신 상태
    freezeWarningType:
      pageState?.freezeWarningType === undefined ? 'all' : pageState?.freezeWarningType,
    recognizedType: pageState?.recognizedType === undefined ? 'all' : pageState?.recognizedType, //계량기 타입
    deviceType: pageState?.deviceType === undefined ? 'all' : pageState?.deviceType, //단말기 타입
    batteryStatus: pageState?.batteryStatus === undefined ? 'all' : pageState?.batteryStatus, //배터리 상태
    signalStrength: 'all', // 전파 신호세기
    temperature: 'all', //온도
    customerStatus: 'all', //as
    isRevised: 'all', //보정
    processStatus: '', // 이미지 인식상태
    startDate: '', //설치일 시작
    endDate: '', //설치일 종료
    diameters: '',
    serverCycle: '', //통신주기 (사업소별 노출)
    rowPerPage: 30,
    page: 1,
  }
}

export const customerInfoNewFilter = (pageState: any) => {
  return {
    page: 1,
    customerName: '',
    customerNumber: '',
    address: '',
    serialNumber: '',
    managerName: '',
    installerName: '',
    memo: '',
    deviceStatus: pageState?.deviceStatus === undefined ? 'all' : pageState?.deviceStatus,
    efosStatus: pageState?.efosStatus === undefined ? 'all' : pageState?.efosStatus,
    freezeWarningType:
      pageState?.freezeWarningType === undefined ? 'all' : pageState?.freezeWarningType,
    recognizedType: pageState?.recognizedType === undefined ? 'all' : pageState?.recognizedType,
    deviceType: pageState?.deviceType === undefined ? 'all' : pageState?.deviceType,
    batteryStatus: pageState?.batteryStatus === undefined ? 'all' : pageState?.batteryStatus,
    signalStrength: 'all', // 전파세기
    temperature: 'all', //온도
    customerStatus: 'all', //수용가 상태
    isRevised: 'all', //보정
    processStatus: '',
    startDate: '', //설치일 시작
    endDate: '', //설치일 종료
    diameters: '',
    rowPerPage: 30,
  }
}

export const customerInfoCorrectFilter = () => {
  return {
    searchOption: {
      customerNumber: false,
      customerName: false,
      address: false,
      managerName: false,
      memo: false,
      serialNumber: false,
      installerName: false,
    },
    imageProcess: [],
    searchData: '',
    deviceStatus: 'all',
    efosStatus: 'all',
    freezeWarningType: 'all',
    recognizedType: 'all',
    deviceType: 'all',
    batteryStatus: 'all',
    rowPerPage: 30,
    page: 1,
  }
}

export const customerActivityFilter = {
  searchOption: {
    customerNumber: false,
    customerName: false,
    managerName: false,
    address: false,
    memo: false,
  },
  searchData: '',
  date: dayjs().format('YYYYMMDD'),
}

export const customerStatusFilter = (pageState: any) => {
  return {
    searchOption: {
      customerNumber: false,
      customerName: false,
      address: false,
      managerName: false,
      memo: false,
      serialNumber: false,
    },
    // date: dayjs('2024-06-19').format('YYYYMMDD'),
    searchData: '',
    deviceStatus: pageState?.deviceStatus === undefined ? 'all' : pageState?.deviceStatus,
    efosStatus: pageState?.efosStatus === undefined ? 'all' : pageState?.efosStatus,
    freezeWarningType: 'all',
    deviceType: pageState?.deviceType === undefined ? 'all' : pageState?.deviceType,
    batteryStatus: pageState?.batteryStatus === undefined ? 'all' : pageState?.batteryStatus,
    recognizedType: pageState?.recognizedType === undefined ? 'all' : pageState?.recognizedType,
    signalStrength: 'all', // 전파세기
    temperature: 'all', //온도
    customerStatus: 'all', //as
    isRevised: 'all', //보정
    processStatus: '',
    rowPerPage: 30,
    page: 1,
  }
}
export const customerCheckListFilter = {
  flag: 'week',
  start: 4,
  end: dayjs().format('YYYYMMDD'),
  rowPerPage: 30,
  page: 1,
  searchOption: {
    customerNumber: false,
    customerName: false,
    address: false,
    managerName: false,
  },
  searchData: '',
}
export const customerCheckListChartFilter = {
  flag: 'month',
  end: dayjs().format('YYYYMM'),

  searchOption: {
    customerNumber: false,
    customerName: false,
    address: false,
  },
  searchData: '',
}
export const customerCheckReportFilter = {
  searchOption: {
    customerNumber: false,
    customerName: false,
    address: false,
    meterDiameter: false,
    managerName: false,
  },
  searchData: '',
  date: dayjs().format('YYYYMM'),
  rowPerPage: 30,
  page: 1,
}
export const customerMinimumFlowFilter = {
  searchOption: {
    address: false,
    customerName: false,
    customerNumber: false,
    managerName: false,
  },
  searchData: '',
  date: dayjs().format('YYYYMMDD'),
  start: 0,
  end: 6,
  flag: false,
  rowPerPage: 30,
  page: 1,
}

export const customerLeakageFilter = {
  searchOption: {
    customerNumber: false,
    customerName: false,
    managerName: false,
    address: false,
  },

  searchData: '',
  date: dayjs().format('YYYYMMDD'),
  rowPerPage: 30,
  page: 1,
}

export const customerFreezeWarningFilter = (pageState: any) => {
  return {
    searchOption: {
      customerNumber: false,
      customerName: false,
      address: false,
      managerName: false,
    },
    searchData: '',
    freezeWarningType:
      pageState?.freezeWarningType === undefined ? 'all' : pageState?.freezeWarningType,
    date: dayjs().format('YYYYMMDD'),
    rowPerPage: 30,
    page: 1,
  }
}

export const customerFlaggedReviewFilter = () => {
  return {
    page: 1,
    searchKeyword: '', // searchTarget 드롭다운 확정 전까지 필터 없이 통합 검색
    deviceStatus: 'all', //단말기 통신 상태
    batteryStatus: 'all', //배터리 상태
    efosStatus: 'all', //계량기 통신 상태
    deviceType: 'all', //단말기 타입
    recognizedType: 'all', //계량기 타입
    isRevised: 'all', //이미지 보정
    signalStrength: 'all', //신호 세기
    temperature: 'all', //온도
    customerStatus: 'all', //수용가 상태
    diameters: '', //구경(다중선택)
    excludeAsStatus: false, //AS 상태 수용가 제외
    startIssueDate: dayjs().subtract(7, 'day').format('YYYYMMDD'), //이슈 조회 시작일
    endIssueDate: dayjs().format('YYYYMMDD'), //이슈 조회 종료일
    issueTypes: [] as string[], //상단 조건 chip (CustomerIssueType 다중 토글)
    rowPerPage: 30,
  }
}

export const customerBinaryCheckFilter = (pageState: any) => {
  return {
    searchOption: {
      customerNumber: false,
      customerName: false,
      address: false,
      managerName: false,
      memo: false,
      serialNumber: false,
      installerName: false,
    },
    searchData: '',
    deviceStatus: 'all', // 단말기 통신 상태
    efosStatus: 'all', //계량기 통신 상태
    recognizedType: 'all', //계량기 타입
    customerStatus: 'all', //as
    compareType: 'all', //이미지 검증 상태
    startDate: dayjs().subtract(7, 'day').format('YYYYMMDD'), //시작 날짜
    endDate: dayjs().format('YYYYMMDD'), //마지막 날짜
    rowPerPage: 30,
    page: 1,
  }
}
